import { type Email } from "~/state/types";

export function isEmail(o: unknown): o is Email {
	return !!o && typeof o === "object" && "type" in o && o.type === "Email";
}
